<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['s', 'p', 'b', 'c', 'o', 't'].map(v => {
			return { value: v, label: 'Level ' + v.toUpperCase() };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

